// File: FileUploadContext.tsx
import React, { createContext, useContext, useState, ReactNode, SetStateAction, Dispatch } from 'react';

interface FileUploadContextProps {
  selectedFile: File | null;
  setFile: Dispatch<SetStateAction<File | null>>;
}

const FileUploadContext = createContext<FileUploadContextProps | undefined>(undefined);

interface FileUploadProviderProps {
  children: ReactNode;
}

export const FileUploadProvider: React.FC<FileUploadProviderProps> = ({ children }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const setFile: FileUploadContextProps['setFile'] = (file) => {
    setSelectedFile(file);
  };

  return (
    <FileUploadContext.Provider value={{ selectedFile, setFile }}>
      {children}
    </FileUploadContext.Provider>
  );
};

export const useFileUpload = (): FileUploadContextProps => {
  const context = useContext(FileUploadContext);
  if (!context) {
    throw new Error('useFileUpload must be used within a FileUploadProvider');
  }
  return context;
};
